import { FormControl, MenuItem, Select } from "@mui/material";
import {
  SUMMER_CAMPAIGN_LEAD_CONTACT_STATUSES,
  contactStatusLabel,
  type SummerCampaignLeadContactStatus,
} from "@shared/helpers/summer-campaign-lead-communication";
import { linko } from "@shared/linko";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type FC } from "react";
import { useAlert } from "../../../contexts/AlertProvider";
import { patchLeadContactStatusInList } from "../../../queries/invalidate-lead-handling";

type Props = {
  leadId: string;
  contactStatus: string;
  disabled?: boolean;
  onUpdated?: () => void;
};

export const LeadContactStatusSelect: FC<Props> = ({
  leadId,
  contactStatus,
  disabled,
  onUpdated,
}) => {
  const queryClient = useQueryClient();
  const { setAlertText, setSeverity } = useAlert();
  const mutation = useMutation({
    mutationFn: async (nextStatus: SummerCampaignLeadContactStatus) => {
      await linko.summerCampaignLead.mutations.updateLeadContactStatus({
        leadId,
        contactStatus: nextStatus,
      });
      return nextStatus;
    },
    onSuccess: (nextStatus) => {
      patchLeadContactStatusInList(queryClient, leadId, nextStatus);
      onUpdated?.();
    },
    onError: (err: Error) => {
      setSeverity("error");
      setAlertText(err.message || "לא ניתן לעדכן סטטוס יצירת קשר");
    },
  });

  return (
    <FormControl size="small" fullWidth disabled={disabled || mutation.isPending}>
      <Select
        value={contactStatus}
        onChange={(e) =>
          mutation.mutate(e.target.value as SummerCampaignLeadContactStatus)
        }
        sx={{ fontSize: "0.8rem" }}
      >
        {SUMMER_CAMPAIGN_LEAD_CONTACT_STATUSES.map((status) => (
          <MenuItem key={status} value={status}>
            {contactStatusLabel(status)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
